import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { BannerManagementContainerComponent } from './banner-management-container.component';
import { BannerManagementListComponent } from './banner-list/banner-management-list.component';
import { BannerEditComponent } from './banner-edit/banner-edit.component';
import { NgOptimizedImage } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';

const routes: Routes = [
  { path: '', component: BannerManagementContainerComponent, data: { title: 'Banner Management' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BannerManagementContainerRoutingModule {}

@NgModule({
  imports: [
    BannerManagementContainerRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    NgOptimizedImage,
    DragDropModule,
  ],
  declarations: [
    BannerManagementContainerComponent,
    BannerManagementListComponent,
    BannerEditComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BannerManagementContainerModule {}
